import { Pipe, type PipeTransform } from '@angular/core';
import { CustomerType } from '@shared/zigra-schemas/zigra-schema.autogenerated.models';

@Pipe({
    name: 'zCustomerPrimaryContactAddress'
})
export class CustomerPrimaryContactAddressPipe implements PipeTransform {
    transform(customer: CustomerType | undefined, asString?: boolean) {
        const contactAddress = customer?.Addresses?.filter(
            (filter) => filter.Type == 'S' && filter.IsPrimary == true
        )?.[0];

        const address =
            contactAddress ??
            customer?.Addresses?.filter((filter) => filter.Type == 'S')?.[0] ??
            customer?.Addresses?.filter(
                (filter) => filter.Type == 'C' && filter.IsPrimary == true
            )?.[0] ??
            customer?.Addresses?.filter((filter) => filter.Type == 'C')?.[0] ??
            customer?.Addresses?.[0];

        if (asString)
            return `${address?.StreetName ?? ''} ${address?.StreetNumber ?? ''} ${address?.CityEx ?? ''} ${address?.City?.Title ?? ''} ${address?.PostalCode ?? ''}`.trim();

        return address;
    }
}
